/* eslint-disable @typescript-eslint/no-explicit-any */
import {
  Box,
  Card,
  CardContent,
  CardHeader,
  IconButton,
  Typography,
} from "@mui/material";
import React, { useState } from "react";
import { saveAs } from "file-saver";
const styles = {
  viewer: {
    padding: 2,
  },
  title: {
    fontFamily: "Lato",
    fontSize: 18,
  },
};

const ImageViewer = (props: any) => {
  const [attachmentUrl] = useState(props.url);

  function downloadFile(filePath: string) {
    filePath = attachmentUrl;
    const link = document.createElement("a");
    link.href = filePath;
    link.setAttribute("download", `FileName.jpg`);
    link.setAttribute('target', '_blank');
    link.click();

    saveAs(filePath, "download.jpg");
  }
  const handleDownload = () => {
    downloadFile(attachmentUrl);
  };
  return (
    <Card sx={styles.viewer}>
      <CardHeader
        title={<Typography style={styles.title}>Attachment View</Typography>}
        action={
          <Box>
            <IconButton onClick={handleDownload}>
              <i className="las la-cloud-download-alt"></i>
            </IconButton>

            <IconButton onClick={props.onClose}>
              <i className="las la-times"></i>
            </IconButton>
          </Box>
        }
      />
      <CardContent>
        {props?.img && (
          <img
            src={attachmentUrl}
            height={props.height ? props.height : "470px"}
            width={props.width ? props.width : "100%"}
            style={{
              borderStyle: "none",
              backgroundColor: "white",
            }}
          />
        )}
        {props?.pdf && (
          <iframe
            src={attachmentUrl}
            height="660px"
            width="100%"
            frameBorder="0"
            title="viewer"
            style={{
              border: 'none',
              backgroundColor: 'white',
            }}
            allow="accelerometer; autoplay; clipboard-write; encrypted-media; gyroscope; picture-in-picture; fullscreen"
          />

        )}
      </CardContent>
    </Card>
  );
};

export default ImageViewer;
